(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-customers"]) return;
  try {
    
  (() => {
    const panels = () => ({
      login: document.getElementById('login'),
      recover: document.getElementById('recover'),
    });

    const syncRecover = () => {
      const { login, recover } = panels();
      if (!login || !recover) return;
      const showRecover = location.hash === '#recover' || !!recover.querySelector('[data-hs-recover-success], .hs-account__errors');
      recover.hidden = !showRecover;
      login.hidden = showRecover;
    };

    window.addEventListener('hashchange', syncRecover);
    document.addEventListener('DOMContentLoaded', syncRecover);
    syncRecover();

    document.addEventListener('submit', (event) => {
      const message = event.target.dataset?.hsConfirm;
      if (message && !window.confirm(message)) event.preventDefault();
    });

    const initProvinces = () => {
      if (!window.Shopify?.CountryProvinceSelector) return;
      for (const select of document.querySelectorAll('[data-hs-country]')) {
        const id = select.dataset.hsCountry;
        new window.Shopify.CountryProvinceSelector(`AddressCountry_${id}`, `AddressProvince_${id}`, {
          hideElement: `AddressProvinceContainer_${id}`,
        });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProvinces);
    else initProvinces();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-announcement-rotator')) {
    customElements.define(
      'hs-announcement-rotator',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-autoplay')) return;
          const messages = [...this.querySelectorAll('.hs-announcements__message')];
          let index = 0;
          const speed = Math.max(Number(this.dataset.speed) || 5, 2) * 1000;
          this.timer = setInterval(() => {
            if (this.matches(':hover, :focus-within')) return;
            messages[index].hidden = true;
            index = (index + 1) % messages.length;
            messages[index].hidden = false;
          }, speed);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-collection-tabs')) {
    customElements.define(
      'hs-collection-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKeydown);
        }

        onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        };

        onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          this.select(next);
          next.focus();
        };

        select(tab) {
          for (const item of this.tabs) {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector(`#${item.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !selected;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-home-hero')) {
    customElements.define(
      'hs-home-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-go]')];
          this.counter = this.querySelector('[data-current]');
          this.index = 0;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) this.removeAttribute('data-autoplay');
          this.addEventListener('click', this.onClick);
          this.addEventListener('animationend', this.onProgressEnd);
          this.addEventListener('keydown', this.onKeydown);
          this.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.addEventListener('touchend', this.onTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onClick = (event) => {
          const dot = event.target.closest('[data-go]');
          if (dot) this.go(Number(dot.dataset.go));
        };

        onProgressEnd = (event) => {
          if (event.animationName === 'hs-hero-progress') this.go(this.index + 1);
        };

        onKeydown = (event) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (step) this.go(this.index + step);
        };

        onTouchStart = (event) => {
          this.touchX = event.changedTouches[0].clientX;
          this.touchY = event.changedTouches[0].clientY;
        };

        onTouchEnd = (event) => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1));
        };

        onBlockSelect = (event) => {
          const index = this.slides.indexOf(event.target);
          if (index === -1) return;
          this.setAttribute('data-paused', '');
          this.go(index);
        };

        go(index) {
          const count = this.slides.length;
          this.index = ((index % count) + count) % count;
          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === this.index);
            slide.inert = i !== this.index;
          });
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === this.index);
            if (i === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-shop-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-home-shop-tabs')) {
    customElements.define(
      'hs-home-shop-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
        }

        onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        };

        onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (index === -1 || !step) return;
          event.preventDefault();
          const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          this.select(next);
          next.focus();
        };

        select(tab) {
          for (const item of this.tabs) {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector(`#${item.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !selected;
          }
          tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-home-showcase')) {
    customElements.define(
      'hs-home-showcase',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.hs-showcase__slide')];
          this.items = [...this.querySelectorAll('.hs-showcase__item')];
          this.dots = [...this.querySelectorAll('.hs-showcase__dot')];
          this.arrows = [...this.querySelectorAll('.hs-showcase__arrow')];
          this.counter = this.querySelector('[data-current]');
          this.track = this.querySelector('.hs-showcase__track');
          this.stage = this.querySelector('.hs-showcase__stage');
          this.swipe = this.querySelector('.hs-showcase__swipe');
          this.count = this.slides.length;
          this.active = -1;
          this.position = 0;
          if (!this.count) return;

          this.wide = matchMedia('(min-width: 750px)');
          this.calm = matchMedia('(prefers-reduced-motion: reduce)');
          this.wide.addEventListener('change', this.setMode);
          this.calm.addEventListener('change', this.setMode);
          window.addEventListener('scroll', this.queue, { passive: true });
          window.addEventListener('resize', this.queue);
          this.swipe.addEventListener('scroll', this.queue, { passive: true });
          this.swipe.addEventListener('click', this.onSwipeClick);
          this.addEventListener('click', this.onClick);
          this.setMode();
        }

        disconnectedCallback() {
          this.wide?.removeEventListener('change', this.setMode);
          this.calm?.removeEventListener('change', this.setMode);
          window.removeEventListener('scroll', this.queue);
          window.removeEventListener('resize', this.queue);
        }

        // Scroll mode: the stage sticks while the page scrolls past one step per product.
        // Swipe mode (phones, reduced motion, or turned off): a native snap scroller drives the same layout.
        setMode = () => {
          const scroll = this.hasAttribute('data-scroll') && this.wide.matches && !this.calm.matches && this.count > 1;
          this.dataset.mode = scroll ? 'scroll' : 'swipe';
          this.render();
        };

        queue = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.render();
          });
        };

        progress() {
          if (this.dataset.mode === 'scroll') {
            const step = this.stepSize();
            const raw = Math.min(Math.max(-this.track.getBoundingClientRect().top / step, 0), this.count - 1);
            if (raw > 0.02) this.classList.add('is-moved');
            // Each product holds for a moment before the next one slides in.
            const index = Math.floor(raw);
            const t = Math.min(Math.max((raw - index - 0.18) / 0.64, 0), 1);
            return index + t * t * (3 - 2 * t);
          }
          const width = this.swipe.clientWidth;
          return width ? this.swipe.scrollLeft / width : 0;
        }

        stepSize() {
          return (this.track.offsetHeight - this.stage.offsetHeight) / (this.count - 1) || 1;
        }

        render() {
          const p = this.progress();
          const width = this.stage.clientWidth;
          const wide = this.wide.matches;
          const near = wide ? { x: 0.34, scale: 0.56, opacity: 0.8 } : { x: 0.44, scale: 0.46, opacity: 0.7 };

          this.slides.forEach((slide, index) => {
            const d = index - p;
            let x;
            let scale;
            let opacity;
            if (d <= 0) {
              const t = Math.max(d, -1);
              x = t * 0.3;
              scale = 1 + t * 0.12;
              opacity = 1 + t * 1.4;
            } else if (d <= 1) {
              x = d * near.x;
              scale = 1 - d * (1 - near.scale);
              opacity = 1 - d * (1 - near.opacity);
            } else {
              const t = Math.min(d - 1, 1);
              x = near.x + t * 0.2;
              scale = near.scale - t * 0.08;
              opacity = near.opacity * (1 - t);
            }
            slide.style.transform = `translate3d(${(x * width).toFixed(1)}px, 0, 0) scale(${scale.toFixed(4)})`;
            slide.style.opacity = Math.max(opacity, 0).toFixed(3);
            slide.style.zIndex = String(index + 1);
          });

          this.position = p;
          this.setActive(Math.round(p));
        }

        setActive(index) {
          if (index === this.active) return;
          this.active = index;
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          this.items.forEach((item, i) => {
            item.classList.toggle('is-active', i === index);
            item.inert = i !== index;
          });
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
          if (this.counter) this.counter.textContent = String(index + 1).padStart(2, '0');
          this.arrows.forEach((arrow) => {
            const step = Number(arrow.dataset.step);
            arrow.disabled = index + step < 0 || index + step > this.count - 1;
          });
        }

        goTo(index) {
          index = Math.min(Math.max(index, 0), this.count - 1);
          if (this.dataset.mode === 'scroll') {
            const top = this.track.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: top + index * this.stepSize() + 1, behavior: 'smooth' });
          } else {
            this.swipe.scrollTo({ left: index * this.swipe.clientWidth, behavior: this.calm.matches ? 'auto' : 'smooth' });
          }
        }

        onClick = (event) => {
          const go = event.target.closest('[data-go]');
          const arrow = event.target.closest('[data-step]');
          const slide = event.target.closest('.hs-showcase__slide');
          if (go) this.goTo(Number(go.dataset.go));
          else if (arrow) this.goTo(this.active + Number(arrow.dataset.step));
          else if (slide && Number(slide.dataset.index) !== this.active) {
            event.preventDefault();
            this.goTo(Number(slide.dataset.index));
          }
        };

        // The swipe layer sits over the photos, so a tap on it opens whichever photo is under the finger.
        onSwipeClick = (event) => {
          const hit = [this.active, this.active + 1].find((index) => {
            const box = this.slides[index]?.getBoundingClientRect();
            return box && event.clientX >= box.left + box.width * 0.2 && event.clientX <= box.right - box.width * 0.2;
          });
          if (hit === this.active) window.location.href = this.slides[hit].href;
          else if (hit !== undefined) this.goTo(hit);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-page-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hs-page-tabs')) {
    customElements.define(
      'hs-page-tabs',
      class HsPageTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.addEventListener('click', this.#onClick);
          this.addEventListener('keydown', this.#onKeydown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.#onClick);
          this.removeEventListener('keydown', this.#onKeydown);
        }

        select(tab, focus = false) {
          for (const other of this.tabs) {
            const selected = other === tab;
            other.setAttribute('aria-selected', String(selected));
            other.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector(`#${other.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !selected;
          }
          if (focus) tab.focus();
        }

        #onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        };

        #onKeydown = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          this.select(this.tabs[(index + step + this.tabs.length) % this.tabs.length], true);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
